import { Menu } from "@ark-ui/react";
import clsx from "clsx";
import type { ComponentProps } from "react";

type Props = ComponentProps<typeof Menu.Trigger>;

const Trigger = ({ children, className, ...rest }: Props) => {
  return (
    <Menu.Trigger className={clsx("focus-visible:outline-none", className)} {...rest}>
      {children}
    </Menu.Trigger>
  );
};

export default Trigger;
